import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { checked } from '../../assets/svg/other'
import { add, remove, change, print, copy } from '../../assets/svg/footers'
import Select from '../../components/Select'
import { useState } from 'react'
import Modal from './modal'
import { useNavigate, useParams } from 'react-router-dom'
import Table from '../../components/Table'
import { getPersonnelList, getPersonTable } from '../../actions/personnel/personnel'
import { useDispatch, useSelector } from 'react-redux'


const selectValues = [
  { value: 'Работает', label: 'Работает', id: 1 },
  { value: 'Уволен', label: 'Уволен', id: 2 },
  { value: 'Убыл', label: 'Убыл', id: 3 },
  { value: 'Все', label: 'Все', id: 0 },
]

export default function Personnel() {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { personnelId } = useParams()
  const { personnelList } = useSelector((state) => state.personnel)

  const [work, setWork] = useState('Работает')
  const [selectedRow, setSelectedRow] = useState('Работает')
  const [sortField, setSortField] = useState('fio')
  const [sortAsc, setSortAsc] = useState(true)

  const handleSort = (field) => {
    if (sortField === field) setSortAsc(v => !v)
    else { setSortField(field); setSortAsc(true) }
  }

  const sortedList = useMemo(() => {
    if (!personnelList) return []
    return [...personnelList].sort((a, b) => {
      const aVal = a[sortField] ?? ''
      const bVal = b[sortField] ?? ''
      if (typeof aVal === 'number' && typeof bVal === 'number')
        return sortAsc ? aVal - bVal : bVal - aVal
      return sortAsc
        ? String(aVal).localeCompare(String(bVal), 'ru')
        : String(bVal).localeCompare(String(aVal), 'ru')
    })
  }, [personnelList, sortField, sortAsc])

  const openModal = (id) => () => {
    navigate(`/personnel/${id}`)
  }

  const openModalAsync = async (row) => {
    // Режим редактирования - проверяем доступность данных и переходим на страницу
    if (row?.mid) {
      const result = await dispatch(getPersonTable('main', row.mid))
      if (result && !result.success && result.errorCode === 500) {
        return // Не переходим, предупреждение уже показано в action
      }
      navigate(`/personnel/${row.mid}`)
    }
  }

  const goHome = () => navigate('/')

  const closeModal = () => {
    navigate('/personnel')
  }

  useEffect(() => {
    dispatch(getPersonnelList(work))
  }, [work])

  const handleInputChange = (e) => {
    setWork(e.target.value)
  }

  const renderOption = (option, index) => {
    const { value, label, id } = option
    return <option key={`${id}-${index}`} value={value}>{label}</option>
  }

  const handleSelectRow = (row) => {
    setSelectedRow(row)
    // dispatch(getPerson(row.mid))
  }

  const renderRow = (row) => {
    const { fio, login, sex, age, birthday, email,
      residential_address, date_of_birth, blocked,
      registration_address, document_number, department,
      specialization, total_experience, teaching_experience,
      experience_current_organization, mo_experience,
      position, role, Category, position_eligibility, personnel_type,
      work_type, employment_date, mid } = row

    return (
      <tr
        onClick={() => handleSelectRow(row)}
        onDoubleClick={() => openModalAsync(row)}
        style={{ backgroundColor: mid === selectedRow.mid ? '#3689FF' : '' }}
      >
        <td>{fio}</td>
        <td>{checked()}</td>
        <td>{login}</td>
        <td>{!!blocked ? 'Да' : 'Нет'}</td>
        <td>{sex}</td>
        <td>{birthday}</td>
        <td>{date_of_birth}</td>
        <td>{residential_address}</td>
        <td>{registration_address}</td>
        <td>{document_number}</td>
        <td>{date_of_birth}</td>
        <td>{specialization}</td>
        <td>{total_experience}</td>
        <td>{teaching_experience}</td>
        <td>{experience_current_organization}</td>
        <td>{mo_experience}</td>
        <td>{employment_date}</td>
        <td>{position}</td>
        <td>{role}</td>
        <td>{Category}</td>
        <td>{position_eligibility}</td>
        <td>{personnel_type}</td>
        <td>{work_type}</td>
        <td>{date_of_birth}</td>
        <td>{department}</td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      <Modal
        personnelId={personnelId}
        isOpen={!!personnelId}
        closeModal={closeModal}
        addMode={!parseInt(personnelId)}
      />
      <h1>Кадровый состав</h1>
      <div className={styles.filter}>
        <Select
          title='Статус'
          options={selectValues}
          onChange={handleInputChange}
        >
          <option value=''>Выбрать</option>
          {selectValues?.map(renderOption)}
        </Select>
        <Button>Обновить</Button>
      </div>
      <Table className={styles.tables}>
        <thead>
          <tr>
            <th onClick={() => handleSort('fio')} style={{ cursor: 'pointer' }}>Фамилия Имя Отчество</th>
            <th>Фото</th>
            <th onClick={() => handleSort('login')} style={{ cursor: 'pointer' }}>Логин</th>
            <th>Заблокирован</th>
            <th>Пол</th>
            <th>Дата рождения</th>
            <th>ДР (Месяц/День)</th>
            <th>Адрес проживания</th>
            <th> Адрес регистрации</th>
            <th>Номер док-та</th>
            <th>Код подразделения</th>
            <th>Специальность</th>
            <th>Общий стаж</th>
            <th>Педагогический стаж</th>
            <th>Стаж в данной организации</th>
            <th>Стаж МО</th>
            <th>Дата приёма на работу</th>
            <th onClick={() => handleSort('position')} style={{ cursor: 'pointer' }}>Должность</th>
            <th>Роль</th>
            <th>Категория</th>
            <th>Соответствие занимаемой должности</th>
            <th>Тип персонала</th>
            <th>Вид работы</th>
            <th>Воинское звание</th>
            <th onClick={() => handleSort('department')} style={{ cursor: 'pointer' }}>Подразделение</th>
          </tr>
        </thead>
        <tbody>
          {sortedList.map(renderRow)}
        </tbody>
      </Table>
      <br />
      <p className={styles.count}>Количество {personnelList?.length}</p>
      <p className={styles.count}>*Используйте двойной клик для редактирования личного дела</p>
      <footer className={styles.footer}>
        <div>
          <Button className={styles.footerButton} onClick={openModal(0)} mode='bordered'>{add()}Добавить</Button>
          <Button className={styles.footerButton} mode='bordered'>{remove()}Удалить</Button>
          <Button className={styles.footerButton} style={{ padding: '.5rem 0' }}>{print()}Печать Т-2</Button>
          <Button className={styles.footerButton} style={{ padding: '.5rem 0' }}>{copy()}Пароли / Экспорт в AD</Button>
        </div>
        <Button mode='white' onClick={goHome}>Закрыть</Button>
      </footer>
    </div>
  )
}
